import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import SwipeableTextMobileStepper from "./Carousel";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import {
  getPurchasedList,
} from "../../service/api";
import Loaderpage from "../LoaderPage";
import { Box } from "@material-ui/core";
import Pagination from "../../components/PaginationDealerView";
import PurchaseReceiptComponent from './purchaseReceiptComponent';

export default function PurchasedVehicleList(props) {
  const [vehicleResponse, setVehicleResponse] = useState([]);
  const [loader, setLoader] = React.useState(true);

  useEffect(() => {
    getVehicleDetails(1);
  }, [props.selectedDealersData]);

  async function getVehicleDetails(index) {
    const purchasedListResponse = await getPurchasedList(index);
    setVehicleResponse(purchasedListResponse?.data);
    setLoader(false);
  }

  function getPurchasetype(list) {
    const price = list
      .filter(item => item.price_type !== "Fee")
      .sort((a, b) => a.price_category.localeCompare(b.price_category))
      .map(item => item.price_category)
      .join(' + ');
    return price;
  }
  function getTotprice(list) {
    let price = 0;
    if (list?.length !== 0) {
      list.forEach((x, index) => {
        if (x.sale_amount) {
          price = price += x.sale_amount;
        }
      });
    }
    return price;
  }

  const openConditionReport = (VINumber, vehicle) => {
    props.history.push("/conditionreport", {
      vin: VINumber,
      vehicleDetails: vehicle,
    });
  };
  const onChangePage = (data, index) => {
    // console.log("data", data);
    getVehicleDetails(index);
  };

  return vehicleResponse?.length > 0 ? (
    <div>
      {vehicleResponse.map((vehicle, index) => {
        let imageSrc;
        const brand = vehicle?.brand;
        if(brand != null) {
          switch (brand.toLowerCase()) {
            case "toyota":
              imageSrc = "inspection_pending_tfs.png";
              break;
            case "lexus":
              imageSrc = "inspection_pending_lfs.png";
              break;
            case "mazda":
              imageSrc = "inspection_pending_mfs.png";
              break;
          }
        }
        else {
          const tenantId = localStorage.getItem("tenantId");
          if (tenantId != null) {
            switch (tenantId.toLowerCase()) {
              case "t001":
                imageSrc = "inspection_pending_tfs.png";
                break;
              case "t002":
                imageSrc = "inspection_pending_mfs.png";
                break;
            }
          }
        }
        if (!imageSrc) {
          imageSrc = "inspection_pending_tfs.png";
        }

        return (
          <div className="listingPageCard" key={index}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                {vehicle?.groundingImage ? (
                  <SwipeableTextMobileStepper
                    vehical={vehicle}
                    images={vehicle?.groundingImage}
                  />
                ) : (
                  <div className="pendingImgBlock">
                    <img
                      className="pendingImg"
                      src={imageSrc}
                      alt="pending"
                    />
                  </div>
                )}
              </Grid>
              <Grid item xs={4}>
                <div className="Year-Make-Model-Col">
                  <div className="vehicleMakeModel">
                    <span>
                      {vehicle?.model_year} {vehicle?.brand} {vehicle?.model}
                      {vehicle?.ext_color}
                    </span>
                  </div>
                  <List>
                    <span className="textStyle">
                      <span className="textBold"> VIN:</span>
                      <button style={{ cursor: 'pointer', border: 'none', background: 'none' }}
                        className="vin"
                        onClick={() => openConditionReport(vehicle?.vin, vehicle)}
                      >
                        {" "}
                        &nbsp;
                        {vehicle?.vin}
                      </button>
                    </span>

                    <span className="textStyle">
                      <span className="textBold"> Purchase Date : </span>
                      {vehicle?.sale_date && moment(vehicle?.sale_date).format("MM/DD/YYYY")}
                    </span>
                    <span className="textStyle">
                      <span className="textBold"> Purchase Type : </span>
                      {getPurchasetype(vehicle?.priceCategoryList)}
                    </span>
                    <span className="textStyle">
                      <span className="textBold"> Purchase Receipt : </span>
                      {' '}<PurchaseReceiptComponent vin={vehicle?.vin} />
                    </span>
                    <span className="textStyle">
                      <span className="textBold"> Purchase Venue : </span>
                      {' '}{vehicle?.saleVenue}
                    </span>
                  </List>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div className="Vehicle-Price-Option">
                  <div className="vehicleMakeModel">
                    <span>Vehicle Cost </span>
                  </div>
                  <List>
                    {vehicle?.priceCategoryList && vehicle?.priceCategoryList.sort((a, b) => {
                      const typeOrder = a.price_type === "Price" ? -1 : 1;
                      const typeOrderB = b.price_type === "Price" ? -1 : 1;
                      if (typeOrder !== typeOrderB) return typeOrder - typeOrderB;
                      return a.price_category.localeCompare(b.price_category);
                    })?.map((priceitem, index) =>
                      <span key={index} className="textStyle priceOptions">
                        <span className="textBold"> {priceitem?.price_category} {priceitem?.price_type} </span>
                        <span className="">
                          <CurrencyFormat
                            value={
                              priceitem &&
                              parseFloat(
                                priceitem?.sale_amount
                              ).toFixed(2)
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                        </span>
                      </span>
                    )

                    }
                    <div className="purchasedScreenTotal" />
                    <span className="textStyle priceOptions">
                      <span className="textStyleTotalFee"> Total Price</span>
                      <span className="totalFeeSum">
                        <CurrencyFormat
                          value={parseFloat(
                            getTotprice(vehicle.priceCategoryList)
                          ).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </span>
                    </span>
                  </List>
                </div>
              </Grid>
            </Grid>

          </div>
        );
      })

      }
      {vehicleResponse?.length !== 0 ? (
        <Pagination
          showItemsPerPage={20}
          data={vehicleResponse}
          onChangePage={onChangePage}
        />
      ) : null}
    </div>

  ) : (
    <div>
      {loader ? (
        <Box
          height={"90vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <div>
            <Loaderpage />
            <span className="loaderText">Loading...</span>
          </div>
        </Box>
      ) : (
        <div className="listingPageCardNoData">
          <img alt="nodatafound" src="noDataFound.jpeg" className="nodataImage" />
          <span className="nodataText">No Vehicles found</span>
        </div>
      )}
    </div>
  );
}
